import "core-js/modules/web.dom-exception.stack.js";
import QRCode from 'qrcode';
import Cookies from 'cookies-js';
const year50 = 60 * 60 * 24 * 365 * 50;
export default {
  name: 'LoginIndex',
  props: {
    //推广邀请人ID
    inviteId: {
      type: String
    },
    //推广邀请人Code
    inviteCode: {
      type: String
    },
    //推广来源
    registSource: {
      type: String
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: {
        phone: '',
        verificationCode: '',
        registDevice: 'PC'
      },
      pswForm: {
        username: '',
        password: ''
      },
      bindForm: {
        phone: '',
        verificationCode: '',
        ticket: '',
        registDevice: 'PC'
      },
      countdown: 0,
      cdSet: '',
      errorTips: '',
      isLoginSuccess: false,
      showLoginDialog: true,
      showBindDialog: false,
      submiting: false,
      loginType: 2,
      puid: '',
      checkLogin: ''
    };
  },
  watch: {
    // 11位数字
    'form.phone'(newV, oldV) {
      if (isNaN(newV)) {
        this.form.phone = oldV;
        return;
      }
      this.errorTips = '';
      this.form.phone = newV.replace(/ /g, '');
    },
    'form.verificationCode'(newV, oldV) {
      if (isNaN(newV)) {
        this.form.verificationCode = oldV;
        return;
      }
      this.errorTips = '';
      this.form.verificationCode = newV.replace(/ /g, '');
    },
    // 11位数字
    pswForm() {
      this.errorTips = '';
    },
    bindForm() {
      this.errorTips = '';
    },
    loginType(val) {
      if (val == 2) {
        this.getWXUrl();
      } else {
        clearInterval(this.checkLogin);
        this.checkLogin = '';
      }
    }
  },
  computed: {
    isMobile() {
      return /Mobi|Android|iPhone/i.test(navigator.userAgent);
    },
    formInviteId() {
      var _this$$route$query;
      return this.inviteId || ((_this$$route$query = this.$route.query) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.inviteId) || sessionStorage.getItem('inviteId');
    },
    formInviteCode() {
      var _this$$route$query2;
      return this.inviteCode || ((_this$$route$query2 = this.$route.query) === null || _this$$route$query2 === void 0 ? void 0 : _this$$route$query2.inviteCode) || sessionStorage.getItem('inviteCode');
    },
    formRegistSource() {
      var _this$$route$query3;
      if (this.$route.name == 'SignCreator') {
        return 'VLIAN_CREATOR';
      }
      if (this.$route.name == 'Cooperation') {
        return 'VLIAN_IMG_PURCHASE';
      }
      return this.registSource || ((_this$$route$query3 = this.$route.query) === null || _this$$route$query3 === void 0 ? void 0 : _this$$route$query3.registSource) || sessionStorage.getItem('registSource');
    }
  },
  beforeUnmount() {
    clearInterval(this.checkLogin);
    clearInterval(this.cdSet);
    this.checkLogin = '';
    this.cdSet = '';
  },
  mounted() {
    if (this.isMobile) {
      this.loginType = 0;
    }
    if (this.loginType == 2) {
      this.getWXUrl();
    }
    // console.log(this.$props);
  },

  methods: {
    getWXUrl() {
      clearInterval(this.checkLogin);
      this.checkLogin = '';
      this.$service.ApiCommonGetQrCode({}, {
        retryTimes: 3
      }).then(res => {
        var _res$data;
        if (!res) {
          return;
        }
        const canvas = document.getElementById('wxlogin-qrcode-canvas');
        QRCode.toCanvas(canvas, res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.url, {
          width: 140,
          height: 140,
          margin: 0
        }, error => {
          var _res$data2;
          if (error) console.error(error);
          this.rolling((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.ticket);
        });
      }).catch(() => {});
    },
    rolling(ticket) {
      this.checkLogin = setInterval(() => {
        this.$service.ApiCommonCheckLogin({
          ticket
        }).then(res => {
          var _res$data3, _res$data5;
          // 已扫码已绑定
          if (res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.token) {
            var _res$data4;
            localStorage.setItem('token', res.data.token || '');
            Cookies.set('token1', (res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.token) || '', {
              path: '/',
              domain: '.vlian.cn',
              expires: year50
            });
            this.getUserInfo();
            clearInterval(this.checkLogin);
            this.checkLogin = '';
            return;
          }
          // 已扫码未绑定
          if (res !== null && res !== void 0 && (_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.needBind) {
            this.showBindDialog = true;
            clearInterval(this.checkLogin);
            this.bindForm.ticket = ticket;
            this.checkLogin = '';
            return;
          }
        }).catch(err => {
          console.error(err);
          clearInterval(this.checkLogin);
          this.checkLogin = '';
        });
      }, 2 * 1000);
    },
    bindPhone() {
      this.$service.ApiCommonPhone({
        ...this.bindForm,
        inviteId: this.formInviteId,
        inviteCode: this.formInviteCode,
        registSource: this.formRegistSource
      }, this.$JSON_HEADER).then(res => {
        var _res$data6;
        if (res !== null && res !== void 0 && (_res$data6 = res.data) !== null && _res$data6 !== void 0 && _res$data6.token) {
          var _res$data7;
          localStorage.setItem('token', res.data.token || '');
          Cookies.set('token1', (res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.token) || '', {
            path: '/',
            domain: '.vlian.cn',
            expires: year50
          });
          this.getUserInfo();
          clearInterval(this.checkLogin);
          this.checkLogin = '';
          return;
        }
      }).catch(err => {
        this.errorTips = err.message;
      });
    },
    sendBindSms() {
      if (this.countdown) return;
      const {
        phone
      } = this.bindForm;
      if (!phone || phone.length !== 11) {
        this.errorTips = '请输入11位数字手机号码';
        return;
      }
      this.countdown = 60;
      this.cdSet = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          clearInterval(this.cdSet);
        }
      }, 1000);
      this.$service.ApiCommonSendUserSmsCodeBind(this.bindForm, this.$JSON_HEADER).then(() => {}).catch(err => {
        console.log(err);
        this.errorTips = '请重新获取验证码';
        setTimeout(() => {
          this.errorTips = '';
        }, 2000);
        this.countdown = 0;
        clearInterval(this.cdSet);
      });
    },
    sendSms() {
      if (this.countdown) return;
      const {
        phone
      } = this.form;
      if (!phone || phone.length !== 11) {
        this.errorTips = '请输入11位数字手机号码';
        return;
      }
      this.countdown = 60;
      this.cdSet = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          clearInterval(this.cdSet);
        }
      }, 1000);
      this.$service.ApiCommonSendUserSmsCode(this.form, this.$JSON_HEADER).then(() => {}).catch(err => {
        console.log(err);
        this.errorTips = '请重新获取验证码';
        setTimeout(() => {
          this.errorTips = '';
        }, 2000);
        this.countdown = 0;
        clearInterval(this.cdSet);
      });
    },
    clearErrorTips() {
      this.errorTips = '';
    },
    login() {
      //获取邀请人id
      if (this.submiting) return;
      if (this.loginType) {
        this.loginByPsw();
        return;
      }
      const {
        phone,
        verificationCode
      } = this.form;
      if (!phone || phone.length !== 11) {
        this.errorTips = '请输入11位数字手机号码';
        return;
      }
      if (!verificationCode || verificationCode.length !== 6) {
        this.errorTips = '请输入6位数字验证码';
        return;
      }
      this.submiting = true;
      this.$service.ApiCommonUserPhoneLoginReg({
        ...this.form,
        inviteId: this.formInviteId,
        inviteCode: this.formInviteCode,
        registSource: this.formRegistSource
      }, this.$JSON_HEADER).then(res => {
        var _res$data8, _res$data9;
        localStorage.setItem('token', (res === null || res === void 0 ? void 0 : (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.token) || '');
        Cookies.set('token1', (res === null || res === void 0 ? void 0 : (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.token) || '', {
          path: '/',
          domain: '.vlian.cn',
          expires: year50
        });
        this.getUserInfo();
      }).catch(err => {
        console.log(err);
        this.submiting = false;
        this.errorTips = err.message;
      });
    },
    // 账号密码登录
    loginByPsw() {
      if (this.submiting) return;
      const {
        username,
        password
      } = this.pswForm;
      if (!username || !password) {
        this.errorTips = '请输入密码';
        return;
      }
      this.submiting = true;
      const ts = new Date().getTime() * 1000;
      this.$service.ApiCommonUserPasswordLogin({
        username,
        ts,
        password: window.btoa(`${password}${ts}`)
      }, this.$JSON_HEADER).then(res => {
        var _res$data10, _res$data11;
        localStorage.setItem('token', (res === null || res === void 0 ? void 0 : (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.token) || '');
        Cookies.set('token1', (res === null || res === void 0 ? void 0 : (_res$data11 = res.data) === null || _res$data11 === void 0 ? void 0 : _res$data11.token) || '', {
          path: '/',
          domain: '.vlian.cn',
          expires: year50
        });
        this.getUserInfo();
      }).catch(err => {
        console.log(err);
        this.submiting = false;
        this.errorTips = err.message;
      });
    },
    getUserInfo() {
      this.$service.ApiCommonGetUserInfo({}).then(res => {
        this.$sendAction({
          action: 'login'
        });
        this.pushBaidu(49);
        this.showLoginDialog = false;
        this.isLoginSuccess = true;
        this.submiting = false;
        this.$store.dispatch('$setUserInfo', res.data);
      }).catch(() => {
        Cookies.set('token1', '', {
          path: '/',
          domain: '.vlian.cn'
        });
        Cookies.set('token', '', {
          path: '/',
          domain: '.vlian.cn'
        });
      });
    },
    handleClose() {
      this.showLoginDialog = false;
    },
    closed() {
      this.callback(this.isLoginSuccess);
      this.$emit('closed');
    },
    pushBaidu(type) {
      var _this$$route$query4;
      // type : 1.加入购物车 2.订单提交成功 3.商品下单成功 4.商品支付成功
      if ((_this$$route$query4 = this.$route.query) !== null && _this$$route$query4 !== void 0 && _this$$route$query4.bd_vid) {
        this.$service.ApiBaiduUploadConvertData({
          type,
          url: window.location.href
        }).then(() => {}).catch(err => {
          console.log(err);
        });
      }
    }
  }
};